import React from 'react';
import { CheckCircle2 } from 'lucide-react';
interface HighlightsListProps {
  highlights: string[];
}
export function HighlightsList({
  highlights
}: HighlightsListProps) {
  return <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-39">
      {highlights.map((highlight, idx) => <li key={idx} className="flex items-start gap-3 group" data-id="element-40">
          <CheckCircle2 className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0 group-hover:text-blue-700 transition-colors print:text-black" data-id="element-41" />
          <span className="text-slate-700 leading-relaxed print:text-black" dangerouslySetInnerHTML={{
        __html: highlight
      }} data-id="element-42" />
        </li>)}
    </ul>;
}